const PAGINATION_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
} as const;

const INIT_PAGINATION = {
  limit: 100,
  offset: 0,
  order: PAGINATION_ORDER.DESC,
  count: 0
} as const;

export { PAGINATION_ORDER, INIT_PAGINATION };
